import { render, staticRenderFns } from "./Passwordset.vue?vue&type=template&id=abc589a6&scoped=true"
import script from "./Passwordset.vue?vue&type=script&lang=js"
export * from "./Passwordset.vue?vue&type=script&lang=js"
import style0 from "./Passwordset.vue?vue&type=style&index=0&id=abc589a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc589a6",
  null
  
)

export default component.exports